export default {
	notPermitted: 'No permission to perform this action',
	confirmDelete: 'Are you sure you want to delete this?',
	successfullyDeleted: 'Successfully deleted!',
	successfullyEdited: 'Successfully edited!',
	successfullyAdded: 'Successfully added!',
	loseUnsavedChanges: 'Unsaved changes will be lost!',
	unsavedChanges: 'You have unsaved changes!',
	discard: 'Are you sure you want to discard changes?',
	loading: 'Loading',
	result: 'Result',
	search: 'Search',
	created: 'Created',
	complete: 'Finish',
	public: 'Public',
	unspecified: 'Unspecified',
	yes: 'Yes',
	no: 'No',
	remove: 'Remove',
	nothing: 'Nothing',
	close: 'Close',
	none: 'None',
	all: 'All',
	own: 'Own',
	confirm: 'Confirm',
	add: 'Add',
	edit: 'Edit',
	delete: 'Delete',
	view: 'View',
	save: 'Save | Saved',
	reset: 'Reset',
	comment: 'Comment',
	addComment: 'Add comment',
	cancel: 'Cancel',
	keep: 'Keep',
	leave: 'Leave',
	select: 'Select',
	name: 'Name',
	continue: 'Continue',
	limit: 'and {0} more',
	validField: 'Field must not be empty!',
	validName: 'Name is required!',
	validInstance: 'Instance is required!',
	filterOpt: 'Column and filter options',
	connectionOpt: 'Connection column options',
	connectionObjOpt: 'Connected objects filter options',
	import: 'Import',
	export: 'Export',
	publish: 'Publish',
	undefined: 'Undefined',
	clearFilters: 'Clear all filters',
	theme: 'Theme',
	user: 'User',
	role: 'Role',
	giveAwayResponsibilities: 'Change Responsible',
	successfullyResponsibilityChanged: 'Responsibility changed successfully',
	replaceRoleResponsibilities: 'Give all responsibilities to another role',
}
